import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchOption, editOption, deleteOption, clearOptionsErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditItem from '../components/options/EditOption';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  options: PropTypes.object,
  option: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class OptionEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchOption(this.props.params.id));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.options.option && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Option edited succesfully!',
        error: false,
      });
    }
  }
  deleteOption(optionId) {
    const options = this.props.options;
    options.delete = true;
    this.setState({ options });
    this.props.dispatch(deleteOption(optionId));
    browserHistory.push('/options?page=1');
  }
  saveEditOption(option) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editOption(option));
  }
  navigateToView(option) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editOption(option));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearOptionsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/options/view/${this.props.option.id}`);
      } else {
        browserHistory.push('/options?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="option component" style={authPage}>
        <h2>Edit Option</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditItem
            option={this.props.option}
            onSave={data => this.saveEditOption(data)}
            onDelete={data => this.deleteOption(data)}
            onView={data => this.navigateToView(data)}
          />
        </div>
      </div>
    );
  }
}

OptionEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionEditPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    options: state.options,
    option: state.options.option,
    error: state.options.error,
  };
}

export default withRouter(connect(mapStateToProps)(OptionEditPage));



// WEBPACK FOOTER //
// ./src/containers/OptionEditPage.js